// Vanilla CSS for MediaDropdown. Prefix: mdd-. Aggregated into libraryStyles.
// option.listItemClassNames / option.divClassNames remain caller-supplied.
export const dropdownStyles = `
  .mdd-wrap { width: 100%; position: relative; }
  .mdd-trigger {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .mdd-menu {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 300px;
    border-radius: var(--rad-catchup-xlarge);
    border-width: 3px;
    border-style: solid;
    transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);
    border-color: var(--catchup-blue);
    background-color: var(--catchup-white);
    padding: 1rem;
    transform: translateX(50%);
    right: 50%;
    margin-top: 0.5rem;
    z-index: 10;
  }
  .mdd-menu-open { opacity: 1; visibility: visible; }
  .mdd-menu-closed { opacity: 0; visibility: hidden; }
  /* near the bottom of the activity card the menu opens upward instead of being clipped */
  .mdd-menu-up { top: auto; bottom: 100%; margin-top: 0; margin-bottom: 0.5rem; }
  .mdd-item {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    cursor: pointer;
  }
  .mdd-divider {
    width: 100%;
    border-width: 1px;
    border-style: solid;
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
    border-color: var(--catchup-light-blue);
    border-radius: var(--rad-catchup-full);
  }
`;
